<template>
  <div class="standalone-auth">
    <div class="standalone-auth__card">
      <div class="standalone-loading standalone-loading--inline">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
      <p class="standalone-auth__status">Completing sign-in…</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useSessionStore } from "@/stores/session";

export default defineComponent({
  name: "Callback",
  setup() {
    const session = useSessionStore();

    onMounted(async () => {
      // Capture the callback's query string and clear the URL FIRST, before
      // any async work. `session.status` can flip to "ready" partway through
      // `completeAuth0Callback` (org auto-selected), which fires main.ts's
      // watcher — `singleSpa.navigateToUrl(homePath)` — synchronously ahead
      // of this function's continuation. Clearing the URL AFTER that point
      // used to overwrite the just-navigated-to home path with "/", landing
      // on an empty outlet. Doing it first means the URL is already clean by
      // the time anything reacts to the status change.
      const search = window.location.search;
      window.history.replaceState(null, "", "/");
      try {
        await session.completeAuth0Callback(search);
      } catch (e) {
        // Login.vue renders `session.errorMessage` — App.vue swaps to it
        // automatically once `status` leaves "authenticating".
        session.fail(e instanceof Error ? e.message : "Authentication failed");
      }
    });

    return {};
  },
});
</script>

<style scoped>
.standalone-auth {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.standalone-auth__card {
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}
.standalone-loading--inline {
  position: static;
  inset: auto;
  background: none;
}
.standalone-auth__status {
  font-size: 13px;
  opacity: 0.7;
  margin: 0;
}
</style>
